import { get, post, put } from "@/modules/request";

type ImagePromptParams = {
  id: number;
  zh: string;
  en: string;
};

export const ApiPutImagePrompt = (params: ImagePromptParams) =>
  put(`/UserImagePrompt`, params);

export const ApiGetImagePrompt = (time?: boolean) =>
  get(`/UserImagePrompt`, { time });

export const ApiPostRefineText = (text: string) =>
  post(`/RefineText`, { text });
